import React from 'react';
import { Provider } from 'react-redux';

import type { AppStore } from '../store';

interface IProps extends React.ComponentProps<any> {
  store: AppStore;
}

export function StoreProvider({ store, children }: IProps) {
  return <Provider store={store}>{children}</Provider>;
}
